export const qubitTranslations = {
  en: {
    // Header
    curriculum: "Curriculum",
    features: "Features",
    reviews: "Reviews",
    contact: "Contact",
    getStarted: "Get Started",
    
    // Hero
    practicalCourse: "🔋 PRACTICAL COURSE",
    heroTitle: "Build Professional Battery Packs with Recycled 18650 Cells",
    heroSubtitle: "Master solid principles while saving costs through our unique recycling approach. Learn hands-on battery pack construction from electronics basics to advanced BMS integration.",
    enrollNow: "Enroll Now",
    viewCurriculum: "View Curriculum",
    
    // Stats
    studentsTrained: "Students Trained",
    courseModules: "Course Modules", 
    practicalLessons: "Practical Lessons",
    costSavings: "Cost Savings",
    
    // Course Modules
    courseCurriculumTitle: "Complete Course Curriculum",
    courseCurriculumSubtitle: "Master battery pack construction through our comprehensive 7-module program, from basic electronics to advanced EV battery analysis.",
    module: "MODULE",
    lessons: "Lessons",
    specialFocus: "🌟 Special Focus: 18650 Cell Recycling",
    specialFocusDesc: "Our unique approach teaches you to recycle and repurpose 18650 cells, reducing battery pack costs by up to 70% while maintaining professional quality.",
    costReduction: "Cost Reduction",
    practicalSkills: "Practical Skills",
    modules: "Modules",
    
    // Features
    whyChooseTitle: "Why Choose Qubit Center?",
    whyChooseSubtitle: "Our practical approach combines solid theoretical foundations with hands-on experience and cost-effective recycling techniques.",
    practicalLearning: "Practical Learning",
    practicalLearningDesc: "Hands-on experience building real battery packs from start to finish",
    costEffectiveRecycling: "Cost-Effective Recycling",
    costEffectiveRecyclingDesc: "Learn to recycle 18650 cells, reducing costs by up to 70%",
    solidPrinciples: "Solid Principles", 
    solidPrinciplesDesc: "Master fundamental electronic and battery principles that last",
    professionalSkills: "Professional Skills",
    professionalSkillsDesc: "Build industry-standard battery packs with proper BMS integration",
    
    courseInfo: "Course Information",
    courseFee: "Course Fee",
    duration: "Duration",
    format: "Format",
    certificate: "Certificate",
    support: "Support",
    enrollToday: "Enroll Today",
    
    // Testimonials
    studentSuccessTitle: "Student Success Stories",
    studentSuccessSubtitle: "Hear from professionals who transformed their careers with our practical battery pack building course.",
    averageRating: "Average Rating from 500+ Students",
    
    // Contact
    readyToStartTitle: "Ready to Start Learning?",
    readyToStartSubtitle: "Get in touch to enroll in our battery pack building course or ask any questions about the curriculum.",
    contactInformation: "Contact Information",
    email: "Email",
    phone: "Phone", 
    address: "Address",
    quickEnrollment: "Quick Enrollment",
    quickEnrollmentDesc: "Ready to start immediately? Click below to secure your spot in the next batch.",
    sendMessage: "Send us a Message",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    message: "Message",
    sendMessageBtn: "Send Message",
    
    // Footer
    quickLinks: "Quick Links",
    allRightsReserved: "All rights reserved",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service"
  },
  ar: {
    // Header - Arabic
    curriculum: "المنهج",
    features: "المميزات",
    reviews: "التقييمات",
    contact: "التواصل",
    getStarted: "ابدأ الآن",
    
    // Hero - Arabic
    practicalCourse: "🔋 دورة عملية",
    heroTitle: "بناء حزم البطاريات الاحترافية بخلايا 18650 المعاد تدويرها",
    heroSubtitle: "أتقن المبادئ الأساسية مع توفير التكاليف من خلال نهجنا الفريد في إعادة التدوير. تعلم بناء حزم البطاريات العملي من أساسيات الإلكترونيات إلى تكامل BMS المتقدم.",
    enrollNow: "سجل الآن",
    viewCurriculum: "عرض المنهج",
    
    // Stats - Arabic
    studentsTrained: "طلاب مدربون",
    courseModules: "وحدات الدورة",
    practicalLessons: "دروس عملية",
    costSavings: "توفير التكلفة",
    
    // Course Modules - Arabic
    courseCurriculumTitle: "منهج الدورة الكامل",
    courseCurriculumSubtitle: "أتقن بناء حزم البطاريات من خلال برنامجنا الشامل المكون من 7 وحدات، من أساسيات الإلكترونيات إلى تحليل بطاريات السيارات الكهربائية المتقدم.",
    module: "الوحدة",
    lessons: "دروس",
    specialFocus: "🌟 التركيز الخاص: إعادة تدوير خلايا 18650",
    specialFocusDesc: "نهجنا الفريد يعلمك إعادة تدوير وإعادة استخدام خلايا 18650، مما يقلل تكاليف حزم البطاريات بنسبة تصل إلى 70% مع الحفاظ على الجودة المهنية.",
    costReduction: "تقليل التكلفة",
    practicalSkills: "مهارات عملية",
    modules: "وحدات",
    
    // Features - Arabic
    whyChooseTitle: "لماذا تختار مركز كيوبت؟",
    whyChooseSubtitle: "نهجنا العملي يجمع بين الأسس النظرية الصلبة والخبرة العملية وتقنيات إعادة التدوير الفعالة من حيث التكلفة.",
    practicalLearning: "التعلم العملي",
    practicalLearningDesc: "خبرة عملية في بناء حزم البطاريات الحقيقية من البداية إلى النهاية",
    costEffectiveRecycling: "إعادة التدوير الفعالة",
    costEffectiveRecyclingDesc: "تعلم إعادة تدوير خلايا 18650، مما يقلل التكاليف بنسبة تصل إلى 70%",
    solidPrinciples: "مبادئ صلبة",
    solidPrinciplesDesc: "أتقن المبادئ الأساسية للإلكترونيات والبطاريات التي تدوم",
    professionalSkills: "مهارات مهنية",
    professionalSkillsDesc: "بناء حزم بطاريات بمعايير الصناعة مع تكامل BMS مناسب",
    
    courseInfo: "معلومات الدورة",
    courseFee: "رسوم الدورة",
    duration: "المدة",
    format: "النمط",
    certificate: "الشهادة", 
    support: "الدعم",
    enrollToday: "سجل اليوم",
    
    // Testimonials - Arabic
    studentSuccessTitle: "قصص نجاح الطلاب",
    studentSuccessSubtitle: "استمع من المحترفين الذين غيروا مسيرتهم المهنية بدورتنا العملية لبناء حزم البطاريات.",
    averageRating: "متوسط التقييم من أكثر من 500 طالب",
    
    // Contact - Arabic
    readyToStartTitle: "مستعد لبدء التعلم؟",
    readyToStartSubtitle: "تواصل معنا للتسجيل في دورة بناء حزم البطاريات أو اسأل أي أسئلة حول المنهج.",
    contactInformation: "معلومات التواصل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    address: "العنوان",
    quickEnrollment: "التسجيل السريع",
    quickEnrollmentDesc: "مستعد للبدء فوراً؟ انقر أدناه لتأمين مقعدك في الدفعة القادمة.",
    sendMessage: "أرسل لنا رسالة",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    message: "الرسالة",
    sendMessageBtn: "إرسال الرسالة",
    
    // Footer - Arabic
    quickLinks: "روابط سريعة",
    allRightsReserved: "جميع الحقوق محفوظة",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة"
  }
};